import { useMemo } from "react";
import { QrAnalyticsPage } from "@wedding/qr-analytics";
import { useWedding } from "../contexts/wedding-context";
import { createAnalyticsApi } from "../lib/api";

/**
 * Organizer adapter for the shared QR-analytics page. The single source of
 * truth lives in `@wedding/qr-analytics`; only the API client (organizer auth)
 * + wedding context differ from the admin adapter.
 */
export function AnalyticsPage() {
  const { wedding, slug } = useWedding();
  const api = useMemo(() => createAnalyticsApi(slug), [slug]);
  return <QrAnalyticsPage slug={slug} wedding={wedding} api={api} />;
}
